import _defineProperty from "/opt/build/repo/website/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "/opt/build/repo/website/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { useId } from '@reach/auto-id';
import first from 'lodash/first';
import React from 'react';
import { useListboxControls } from '../hooks/useListboxControls';
import { InputGroup } from '../InputGroup';
import { ScrollShadow } from '../ScrollShadow';
import { Select } from '../SelectA11Y';
import { LegendChecklistItem } from './Legend.ChecklistItem';
import { LegendItem } from './Legend.Item';
import styles from './Legend.scss';
export var Legend = function Legend(_ref) {
  var _ref$isMultiSelectabl = _ref.isMultiSelectable,
      isMultiSelectable = _ref$isMultiSelectabl === void 0 ? false : _ref$isMultiSelectabl,
      _ref$selectedOptions = _ref.selectedOptions,
      selectedOptions = _ref$selectedOptions === void 0 ? new Set() : _ref$selectedOptions,
      props = _objectWithoutProperties(_ref, ["isMultiSelectable", "selectedOptions"]);

  var _props$sortOptions = props.sortOptions,
      sortOptions = _props$sortOptions === void 0 ? [] : _props$sortOptions;
  var firstOption = sortOptions.length && first(sortOptions);
  var listHeight = props.listHeight || 200;
  var placeholder = firstOption ? firstOption.label : '-';
  var legendId = "cds-legend-".concat(useId());
  var options = props.options.map(function (o, i) {
    return _objectSpread({
      id: "legend-item-".concat(i)
    }, o);
  });

  var _useListboxControls = useListboxControls({
    itemIdPrefix: 'legend-item',
    onChange: props.onChange,
    isMultiSelectable: isMultiSelectable
  }),
      listBoxRef = _useListboxControls.listBoxRef,
      handleClick = _useListboxControls.handleClick,
      handleKeyDown = _useListboxControls.handleKeyDown,
      handleBlur = _useListboxControls.handleBlur,
      setupFocus = _useListboxControls.setupFocus,
      activeDescendantId = _useListboxControls.activeDescendantId;

  var valueLabel = '';
  sortOptions.find(function (option) {
    if (option.value === props.sortValue) {
      valueLabel = option.label;
      return true;
    }
  });
  return React.createElement("div", {
    className: styles.container,
    "data-test": props.dataTest
  }, React.createElement("div", {
    className: styles.selectContainer
  }, !props.hideSort && React.createElement(InputGroup, null, React.createElement(InputGroup.Prefix, {
    dataTest: "sort-prefix",
    disabled: props.disabled
  }, React.createElement(InputGroup.Label, {
    id: legendId
  }, "Sort")), React.createElement(Select, {
    labelId: legendId,
    dataTest: "visualization-legend-select-menu",
    disabled: props.disabled,
    onChange: props.onSortChange,
    placeholder: placeholder,
    valueLabel: valueLabel,
    value: props.sortValue || firstOption.value,
    width: "auto"
  }, sortOptions.map(function (option, i) {
    return React.createElement(Select.Option, {
      key: "".concat(option.value, "-").concat(i),
      label: option.label,
      value: option.value,
      dataTest: "sort-option-".concat(option.value, "-").concat(i)
    });
  })))), React.createElement(ScrollShadow, {
    className: styles.listboxContainer,
    height: listHeight,
    role: isMultiSelectable ? 'listbox' : null,
    ref: listBoxRef,
    onKeyDown: function onKeyDown(event) {
      return handleKeyDown(event, options);
    },
    onMouseDown: function onMouseDown(event) {
      return handleClick(event, options);
    },
    onFocus: setupFocus,
    onBlur: handleBlur,
    ariaMultiselectable: isMultiSelectable,
    ariaActiveDescendent: isMultiSelectable ? activeDescendantId : null
  }, options.map(function (option, index) {
    if (isMultiSelectable) {
      return React.createElement(LegendChecklistItem, {
        ariaLabel: option.ariaLabel,
        dataTest: "chart-legend-item-".concat(index),
        id: option.id,
        key: option.id,
        selected: selectedOptions.has(option.value),
        label: option.label,
        checkboxColor: option.color,
        hoverColor: option.hoverColor,
        highlighted: option.id === activeDescendantId,
        onMouseEnter: function onMouseEnter() {
          return props.onOptionMouseEnter(option);
        },
        onMouseLeave: function onMouseLeave() {
          return props.onOptionMouseLeave(option);
        }
      });
    } else {
      return React.createElement(LegendItem, {
        ariaLabel: option.ariaLabel,
        dataTest: "chart-legend-item-".concat(index),
        id: option.id,
        key: option.id,
        label: option.label,
        colorSwatchColor: option.color,
        hoverColor: option.hoverColor,
        highlighted: option.id === activeDescendantId,
        onMouseEnter: function onMouseEnter() {
          return props.onOptionMouseEnter(option);
        },
        onMouseLeave: function onMouseLeave() {
          return props.onOptionMouseLeave(option);
        }
      });
    }
  })));
};